// Copyright 2026. WebPros International GmbH. All rights reserved.
import { combineReducers } from 'redux';
import {
    IPaginateApiResponse,
    paginateInitialState,
} from 'common/api/resources/Response';
import {
    ActionType,
    getType,
} from 'typesafe-actions';
import * as gpuModelActions from 'common/modules/gpuModels/actions';
import { IGpuModel } from 'common/api/resources/Gpu';

export type GpuModelAction = ActionType<typeof gpuModelActions>;

export interface IGpuModelState {
    list: IPaginateApiResponse<IGpuModel[]>;
}

export type GpuModelState = IGpuModelState;

export const mockGpuModel: IGpuModel = {
    id: 0,
    name: 'NVIDIA H200 NVL',
    vram_mb: 143771,
};

export default combineReducers<GpuModelState, GpuModelAction>({
    list: (state = paginateInitialState, action: GpuModelAction) => {
        switch (action.type) {
        case getType(gpuModelActions.setGpuModelList):
            return action.payload;
        default:
            return state;
        }
    },
});
